'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _settingsPropType = require('../PropTypes/settingsPropType');

var _settingsPropType2 = _interopRequireDefault(_settingsPropType);

var _favoritesPropType = require('../PropTypes/favoritesPropType');

var _favoritesPropType2 = _interopRequireDefault(_favoritesPropType);

var _userPropType = require('../PropTypes/userPropType');

var _userPropType2 = _interopRequireDefault(_userPropType);

var _trackSegmentEvent = require('../helpers/trackSegmentEvent');

var _trackSegmentEvent2 = _interopRequireDefault(_trackSegmentEvent);

var _AddFavorites = require('../AddFavorites');

var _AddFavorites2 = _interopRequireDefault(_AddFavorites);

var _Chevron = require('../Chevron');

var _Chevron2 = _interopRequireDefault(_Chevron);

var _Favorite = require('../Favorite');

var _Favorite2 = _interopRequireDefault(_Favorite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavoritesBar = function (_Component) {
  (0, _inherits3.default)(FavoritesBar, _Component);

  function FavoritesBar() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FavoritesBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FavoritesBar.__proto__ || (0, _getPrototypeOf2.default)(FavoritesBar)).call.apply(_ref, [this].concat(args))), _this), _this.getFavoritesBarClassNames = function () {
      var classes = {};
      classes['quiver-favorites-bar'] = true;
      classes['quiver-favorites-bar--large'] = _this.props.large;
      return (0, _classnames2.default)(classes);
    }, _this.adjustScrollPosition = function (direction) {
      if (direction === 'left') {
        _this.handleScroll(_this.ulRef, _this.ulRef.scrollLeft - _this.ulRef.clientWidth, 150);
      } else if (direction === 'right') {
        _this.handleScroll(_this.ulRef, _this.ulRef.scrollLeft + _this.ulRef.clientWidth, 150);
      }
    }, _this.handleScroll = function (element, to, duration) {
      if (duration <= 0) return;
      var el = element;
      var difference = to - el.scrollLeft;
      var perTick = difference / duration * 10;
      setTimeout(function () {
        el.scrollLeft += perTick;
        _this.handleScroll(el, to, duration - 10);
      }, 10);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FavoritesBar, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          style = _props.style,
          user = _props.user,
          favorites = _props.favorites,
          settings = _props.settings,
          large = _props.large;

      return _react2.default.createElement(
        'div',
        { className: this.getFavoritesBarClassNames(), style: style },
        _react2.default.createElement(
          'div',
          { className: 'quiver-favorites-bar__content' },
          _react2.default.createElement(
            'div',
            {
              className: 'quiver-favorites-bar__content-favorites',
              ref: function ref(el) {
                _this2.scrollRef = el;
              }
            },
            _react2.default.createElement(
              'a',
              {
                className: 'quiver-favorites-bar__content-favorites-title',
                href: '/account/favorites'
              },
              'Favorites'
            ),
            _react2.default.createElement(
              'ul',
              {
                className: 'quiver-favorites-bar__content-favorites-list',
                ref: function ref(el) {
                  _this2.ulRef = el;
                }
              },
              favorites.map(function (favorite) {
                return _react2.default.createElement(_Favorite2.default, {
                  key: favorite._id,
                  favorite: favorite,
                  settings: settings,
                  large: large,
                  onClickLink: function onClickLink(_ref2) {
                    var name = _ref2.name,
                        properties = _ref2.properties;
                    return (0, _trackSegmentEvent2.default)(name, properties);
                  }
                });
              }),
              _react2.default.createElement(_AddFavorites2.default, {
                large: large,
                user: user
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'quiver-favorites-bar__content-favorites-arrows' },
              ['left', 'right'].map(function (dir) {
                return _react2.default.createElement(
                  'div',
                  {
                    key: dir,
                    className: 'quiver-favorites-bar__content-favorites-arrow',
                    onClick: function onClick() {
                      return _this2.adjustScrollPosition(dir);
                    }
                  },
                  _react2.default.createElement(_Chevron2.default, { direction: dir })
                );
              })
            )
          )
        )
      );
    }
  }]);
  return FavoritesBar;
}(_react.Component);

FavoritesBar.propTypes = {
  settings: _settingsPropType2.default,
  favorites: _favoritesPropType2.default,
  style: _propTypes2.default.object,
  user: _userPropType2.default,
  large: _propTypes2.default.bool
};
FavoritesBar.defaultProps = {
  settings: null,
  user: null,
  favorites: [],
  style: {},
  large: false
};
exports.default = FavoritesBar;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/FavoritesBar/FavoritesBar.js
// module id = 576
// module chunks = 11